import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import {
  setOverReportActionsEmployeeList,
  setOverReportRetrieveActions,
  setOverReportActionsExportEmployeeList,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import _ from "lodash";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

const OverallReportEmployee = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [search, setsearch] = useState("");
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [sno, setsno] = useState(0);


  useEffect(() => {
    const payload = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      api_type: state.EmployeeVerificationsNeed.API_TYPE,
      third_party_id: state.EmployeeVerificationsNeed.API_type_ID,
      export_type: "user_cost_details",
    };
    dispatch(setOverReportActionsEmployeeList(payload));
  }, [dtpageindex , search , state.EmployeeVerificationsNeed.API_type_ID]);

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );

  function tochange(e) {
    debouncedSearch(e);
  }

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };


  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const column = useMemo(
    () => [

    {
      Header: "S.NO",
      accessor: "",
      Cell: (row) => {
        console.log(row.row);
        console.log(sno);
        return <p>{Number(sno + row.row.index + 1)}</p>;
      },
    },
//        {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "EMPLOYEE CODE",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "EMPLOYEE NAME",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                {row.row.original.user_id != null && row.row.original.user_id != undefined &&
                
                
                row.row.original.user_id.first_name != undefined && row.row.original.user_id.first_name != null  ? 
                <span>
                  {capitalizeFirstLetter(row.row.original.user_id.first_name)}
                </span>
                :

                <span>{"---"}</span>
      }
              </div>
            </div>
          </>
        );
      },
    },


    // {
    //   Header: "DESIGNATION",
    //   accessor: "",
    //   Cell: (row) => {
    //     return (
    //       <>
    //         <div className="UserName" style={{ cursor: "pointer" }}>
    //           <div className="">
    //             <span>
    //               {row.row.original.user_id.user_role != null &&
    //               row.row.original.user_id.user_role != undefined &&
    //               row.row.original.user_id.user_role != "" &&
    //               row.row.original.user_id.user_role.role != null &&
    //               row.row.original.user_id.user_role.role != undefined &&
    //               row.row.original.user_id.user_role.role != null &&
    //               row.row.original.user_id.user_role.role != "" ?
    //              (
    //                 <>{row.row.original.user_id.user_role.role}</>
    //               ) : (
    //                 "--"
    //               )}
    //             </span>
    //           </div>
    //         </div>
    //       </>
    //     );
    //   },
    // },


    {
      Header: "PHONE NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <span>
                  {row.row.original.user_id != null &&
                  row.row.original.user_id.phone_number != "" &&
                  row.row.original.user_id.phone_number != null &&
                  row.row.original.user_id.phone_number != undefined ? (
                    <>{row.row.original.user_id.phone_number}</>
                  ) : (
                    "--"
                  )}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    state.EmployeeVerificationsNeed.API_TYPE == 0 && {
      Header: "BANK AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <span>{row.row.original.zoho_amount}</span>
              </div>
            </div>
          </>
        );
      },
    },
    state.EmployeeVerificationsNeed.API_TYPE == 1 && {
      Header: "AADHAAR FRONT AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
              <p className="ReportPara">
                  <p className="ReportPara">
                    {row.row.original.aadhar_front}
                  </p>


                </p>            
                
                  </div>
            </div>
          </>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 1 && {
      Header: "AADHAAR BACK AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
              <p className="ReportPara">


                  <p className="ReportPara">
                     {row.row.original.aadhar_back}
                  </p>

                </p>            
                
                  </div>
            </div>
          </>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 1 && {
      Header: "PAN FRONT AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
              <p className="ReportPara">


               
                  <p className="ReportPara">
                     {row.row.original.pan_front}
                  </p>
                </p>            
                
                  </div>
            </div>
          </>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 1 && {
      Header: "AADHAAR NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <p className="ReportPara">
                  <p className="ReportPara">
                    {row.row.original.aadhar_number}
                  </p>


                </p>
              </div>
            </div>
          </>
        );
      },
    },


    state.EmployeeVerificationsNeed.API_TYPE == 2 && {
      Header: "AADHAAR AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <p className="ReportPara">
                  <p className="ReportPara">
                    {row.row.original.aadhar_send_amount}
                  </p>


                </p>
              </div>
            </div>
          </>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 2 && {
      Header: "AADHAAR NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <p className="ReportPara">
                  <p className="ReportPara">
                    {row.row.original.aadhar_number != null && row.row.original.aadhar_number != undefined 
                    
                    &&
                    row.row.original.aadhar_number != ""
                    ?
                    
                  
                    row.row.original.aadhar_number
                  
                  
                  :
                  
                  "---"}
                  </p>


                </p>
              </div>
            </div>
          </>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 2 && {
      Header: "PAN  NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <p className="ReportPara">
                  <p className="ReportPara">
                    {row.row.original.pan_number != undefined &&
                    
                    row.row.original.pan_number != null && row.row.original.pan_number != ""?
                  
                  
                    row.row.original.pan_number

                    :"--"}
                  </p>


                </p>
              </div>
            </div>
          </>
        );
      },
    },



    state.EmployeeVerificationsNeed.API_TYPE == 2 && {
      Header: "PAN AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <p className="ReportPara">

                  <p className="ReportPara">
                     {row.row.original.pan_send_amount}
                  </p>
                </p>
              </div>
            </div>
          </>
        );
      },
    },




    state.EmployeeVerificationsNeed.API_TYPE == 3 &&   {
      Header: " NAME AS PER BANK ",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_holder_name != null &&
            row.row.original.account_holder_name != undefined &&
            row.row.original.account_holder_name != undefined ? (
              <div className="UserName">
                <span>{row.row.original.account_holder_name}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    state.EmployeeVerificationsNeed.API_TYPE == 3 &&  {
      Header: "ACCOUNT NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_number != null &&
            row.row.original.account_number != undefined &&
            row.row.original.account_number != undefined ? (
              <div className="UserName">
                <span>{row.row.original.account_number}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    state.EmployeeVerificationsNeed.API_TYPE == 0 &&   {
      Header: "ACCOUNT NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_number != null &&
            row.row.original.account_number != undefined &&
            row.row.original.account_number != undefined ? (
              <div className="UserName">
                <span>{row.row.original.account_number}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 3 &&   {
      Header: "BANK NAME",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.bank_name != null &&
            row.row.original.bank_name != undefined &&
            row.row.original.bank_name != undefined ? (
              <div className="UserName">
                <span>{row.row.original.bank_name}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

 

    state.EmployeeVerificationsNeed.API_TYPE == 3 &&   {
      Header: "IFSC CODE",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.ifsc_code != null &&
            row.row.original.ifsc_code != undefined &&
            row.row.original.ifsc_code != undefined ? (
              <div className="UserName">
                <span>{row.row.original.ifsc_code}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    state.EmployeeVerificationsNeed.API_TYPE == 3 &&    {
      Header: "TRANSACTION ID ",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.bank_transaction_id != null &&
            row.row.original.bank_transaction_id != ""&&
            row.row.original.bank_transaction_id != undefined &&
            row.row.original.bank_transaction_id != undefined ? (
              <div className="UserName">
                <span>{row.row.original.bank_transaction_id}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    state.EmployeeVerificationsNeed.API_TYPE == 3 &&     {
      Header: "BANK AMOUNT",
      accessor: "bank_send_amount",
      Cell: ({ row }) => {
        const amount = row.original.bank_send_amount;

        // Check if the amount is not null or undefined, then format it
        const formattedAmount =
          amount != null && amount != undefined
            ? parseFloat(amount).toFixed(1)
            : "---";

        return (
          <div className="UserName">
            <span>₹{formattedAmount}</span>
          </div>
        );
      },
    },

    state.EmployeeVerificationsNeed.API_TYPE == 4 && {
      Header: "WHATSAPP AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <span>{row.row.original.whats_app_amount}</span>
              </div>
            </div>
          </>
        );
      },
    },
  ].filter(Boolean),
  [sno]
);
return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Employee List</h3>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/validation"}
                >
                  Report Overview
                </NavLink>
              </li>

              <li class="breadcrumb-item">Employee List</li>
            </ul> */}
          </div>
        </div>
        <br/>

        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "0px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div
            className="col"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/validation");
              }}
            >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
            </button>
            {/* <div
              align="center"
              type="button"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "absolute",
                right: "25px",
              }}
            >
              <a
                class="dnbtn"
                onClick={(e) => {
                  //   const payload = {
                  //     export_type: "user_cost_details",
                  //     api_type: state.EmployeeVerificationsNeed.API_TYPE,
                  //   };
                  //   dispatch(setOverReportRetrieveActions(payload));
                  const payload = {
                    search: search,
                    page_size: 10,
                    page: dtpageindex,
                    api_type: state.EmployeeVerificationsNeed.API_TYPE,
                    third_party_id: state.EmployeeVerificationsNeed.API_type_ID,
                    export_type: "user_cost_details",
                  };
                  dispatch(setOverReportActionsExportEmployeeList(payload));
                }}
              ></a>
            </div> */}  
          </div>
        </div>

        <div style={{ padding: " 0px 40px", marginTop: "30px" }}>
          <ReactTable
            data={state.OverAllReportEmployeeListCall.overAllReportEmployeeList}
            columns={column}
            totalItems={state.OverAllReportEmployeeListCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.OverAllReportEmployeeListCall.Total_Count}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            Filter={true}
            NoFilter ={true}
          />
        </div>
      </div>
    </>
  );
};

export default OverallReportEmployee;
